<app-navbar></app-navbar>

<main>
    <section class="header relative pt-16 items-center flex mt-36 mb-10 ">
        <div class="container mx-auto lg:px-4 px-8">
            <div class="items-center flex flex-wrap justify-center">
                <h3 class="font-semibold tracking-wide text-2xl lg:text-3xl text-center info-color">
                    Banan Terms & Conditions
                </h3>
            </div>
            <p class="text-xl lg:text-2xl mt-4 info-color text-center leading-10">
                Please read our terms and conditions carefully before using our services.
            </p>
            <div class="mx-auto max-w-7xl">
                <div class="mx-auto max-w-4xl">
                    <article class="space-y-6 mt-10 text-gray-600 text-base leading-7">
                        <section>
                            <h4 class="text-xl font-semibold leading-7 text-gray-900 text-justify">1. Issuance </h4>
                            <p class="text-lg text-justify mt-2">
                                Banan provides a digital identity ("we", “us” or “our” refers collectively to Banan)

                                Banan includes an electronic digital identity service to authenticate and share personal
                                and biometric data with stakeholders.

                                These terms and conditions ("Terms") set out the basis on which you ("you" refers to the
                                User) can access and use digital identity data as specified in this document.

                                Your ability to use digital identity data with any government or private entity depends
                                on Banan’s association with that entity, and what has been agreed with the entity.
                            </p>
                        </section>
                        <section>
                            <h4 class="text-xl font-semibold leading-7 text-gray-900">2. Usage Terms </h4>
                            <p class="text-lg text-justify mt-2">
                                <span class="font-bold text-gray-700">2.1</span> You will be required to agree to these
                                terms when registering to use Banan. Please read and understand these terms. If you
                                choose to register in Banan, these terms will constitute an agreement between you and us
                                on the use of Banan and its services.
                            </p>

                            <p class="text-lg text-justify mt-2">
                                <span class="font-bold text-gray-700"> 2.2</span> We may modify these Terms at any time
                                by posting an updated version of the Terms in Banan. We recommend you to check regularly
                                for any modifications to the Terms.
                            </p>

                            <p class="text-lg text-justify mt-2">
                                <span class="font-bold text-gray-700"> 2.3</span> Fees: There are no charges imposed on
                                the use of Banan currently. Nevertheless, we may charge you in the future, by notifying
                                you through the Application.
                            </p>
                            <p class="text-lg text-justify mt-2">
                                <span class="font-bold text-gray-700"> 2.4</span> These Terms apply to you whether you
                                are using Banan as a natural or legal person. If you use Banan as a natural person on
                                behalf of a legal person, you guarantee that you have the required legal capacity to do
                                so.</p>
                        </section>
                        <section>
                            <h4 class="text-lg font-semibold leading-7 text-gray-900">3. Banan’s Account </h4>
                            <p class="text-lg text-justify mt-2">
                                <span class="font-bold text-gray-700">3.1</span> You will need to register in Banan to
                                use the service(s). You are required to provide accurate, complete, and up-to-date
                                information when requested to do so. You acknowledge and agree that:
                            </p>
                            <ul class="list-disc pl-6 space-y-2 text-gray-700 text-justify">
                                <li>
                                    You must follow all instructions we provide you with regarding the registration and
                                    upload of your information.
                                </li>
                                <li>
                                    You grant us the right without charges to use and store any information for the
                                    purpose of providing the service, in accordance with our
                                    <a href="/privacy-policy"
                                        class="primary-color underline hover:text-blue-700">Privacy Policy</a>,
                                    including storing and sharing the data of your own device used for the Banan
                                    application with the client.
                                </li>
                                <li>
                                    Using the application from one device only, and downloading the application on
                                    another device gives us the right to deny access to the application from the
                                    previous device.
                                </li>
                            </ul>

                            <p class="text-lg text-justify mt-2">
                                <span class="font-bold text-gray-700">3.2</span> You are solely responsible for the
                                protection of (identity and application) of registration information and any use of your
                                Banan account. And You agree that:
                            </p>
                            <ul class="list-disc pl-6 space-y-2 text-gray-700 text-justify">
                                <li>
                                    You will not use or attempt to use any of Banan’s services for any purpose not
                                    stated in this document and for any unlawful purpose. </li>
                                <li>
                                    You will immediately inform us of any unauthorized activity and any violation of
                                    your account in Banan.
                                </li>
                            </ul>
                            <p class="text-lg text-justify mt-2">
                                <span class="font-bold text-gray-700">3.3</span> We reserve the right to prevent the use
                                of your account in Banan in our sole discretion.
                            </p>
                            <p class="text-lg text-justify mt-2">
                                <span class="font-bold text-gray-700">3.4</span> You understand and agree that we are
                                entitled to rely on:
                            </p>
                            <ul class="list-disc pl-6 space-y-2 text-gray-700 text-justify">
                                <li>
                                    Validity of your phone number.
                                <li>
                                    You agree to share your verified identity of the participating client in Banan.
                                </li>
                            </ul>


                        </section>
                        <section>
                            <h4 class="text-lg font-semibold leading-7 text-gray-900">4. Privacy Policy </h4>
                            <p class="text-lg text-justify mt-2">
                                Personal information (including any biometric data) you provide while in use of Banan
                                will be collected and stored and used in accordance with our Privacy Policy, the terms
                                of which are incorporated in and form part of these Terms.
                            </p>
                        </section>
                        <section>
                            <h4 class="text-lg font-semibold leading-7 text-gray-900">5. Using Banan</h4>
                            <p class="text-lg text-justify mt-2">
                                <span class="font-bold text-gray-700">5.1</span> We do not guarantee our ability to
                                prevent any illegal or incorrect use of Banan, or to provide any notice of any illegal
                                or incorrect use of Banan and the Services.
                            </p>
                        </section>
                        <section>
                            <h4 class="text-lg font-semibold leading-7 text-gray-900"> 6. Changes and Suspension of
                                Operations </h4>
                            <p class="text-lg text-justify mt-2">
                                We reserve the right to change or correct any errors in Banan, and to change, restrict
                                or discontinue the provision of any of the Services, at any time without prior notice.
                                We will make the necessary efforts to include up-to-date and accurate information in
                                Banan, while reserving the right to delete, modify and update the content of Banan and
                                services at any time and for any reason without prior notice.
                            </p>
                        </section>

                        <section>
                            <h4 class="text-lg font-semibold leading-7 text-gray-900"> 7. Intellectual Property </h4>
                            <p class="text-lg text-justify mt-2">
                                We own all intellectual property rights in Banan and services. By using Banan, you are
                                not granted any license, right or other benefit in Banan.
                            </p>
                        </section>


                        <section>
                            <h4 class="text-lg font-semibold leading-7 text-gray-900"> 8. Disclaimer of Warranty </h4>
                            <p class="text-lg text-justify mt-2">
                                The Services of Banan are provided on an "as is" and"as available" basis, and we and our
                                affiliates, and any of their respective owners, officers, agents or employees, expressly
                                disclaim any and all warranties express, implied, and statutory, including but not
                                limited to, any WARRANTIES of Fitness for a particular purpose, virus-free, Property,
                                and non-infringement of property rights.
                            </p>
                        </section>


                        <section>
                            <h4 class="text-lg font-semibold leading-7 text-gray-900"> 9. Limitation of Liability </h4>
                            <p class="text-lg text-justify mt-2">
                                We and our affiliates, our respective suppliers, any of the owners, officers, members,
                                agents or employees of the Company <br>
                                A) We shall not be liable for any direct, indirect, punitive, incidental, special or
                                consequential damages or losses (including, but not limited to, incidental,
                                consequential, loss of profits or damages resulting from loss of data or business
                                interruption) arising out of or in connection with in any event with the use or
                                inability to use Banan or any of its services, whether based on warranty, contract, tort
                                (including negligence) or any other legal theory, whether we have been advised of the
                                possibility of such damages or not. <br>
                                B) We exclude any and all liability for caused damages, technical problems or failures
                                in any network, computer systems, servers, providers, hardware or software, or the
                                failure of any use due to any technical problems on the internet or on Banan or related
                                services. Including any injury or damage to any user or device of any person in
                                connection with or resulting from the use of Banan or its services.

                            </p>
                        </section>


                        <section>
                            <h4 class="text-lg font-semibold leading-7 text-gray-900"> 10. Indemnifications </h4>
                            <p class="text-lg text-justify mt-2">
                                You acknowledge and agree to indemnify and hold harmless Banan, our affiliates,
                                suppliers and any of the owners, officers or employees and to discharge all of us from
                                any claims, obligations, judgments, costs of litigation, causes of litigation, requests,
                                damages, losses (actual or subsequent), fines or penalties, or other expenses of any
                                kind or nature, arising or in any way connected with your use of " Banan " or its
                                services, including as a result of your breach of these Terms.

                            </p>
                        </section>

                        <section>
                            <h4 class="text-lg font-semibold leading-7 text-gray-900"> 11. Notices </h4>
                            <p class="text-lg text-justify mt-2">
                                We will provide any notifications addressed to you via the Application. The Client will
                                also contact you via the Application to request approval before any action is initiated.

                            </p>
                        </section>

                        <section>
                            <h4 class="text-lg font-semibold leading-7 text-gray-900"> 12. Termination </h4>
                            <p class="text-lg text-justify mt-2">
                                <span class="font-bold text-gray-700">12.1</span>
                                We may terminate or suspend your access to or part of the Application, without prior
                                notice, if we believe that your use violates the terms and conditions or the applicable
                                law or is harmful to the interests of Banan or any third party. Notwithstanding such
                                termination or suspension, you agree that you will continue to be subject to the
                                obligations contained in these Terms and Conditions that by their very nature continue
                                to apply, even after such termination or suspension.
                            </p>
                            <p class="text-lg text-justify mt-2">
                                <span class="font-bold text-gray-700">12.2</span>
                                You may deactivate your account in Banan at any time, and we must keep the account
                                activity for 30 days until our final deactivation is completed. The previous saved data
                                will be still in possession of Banan and Banan’s Client even after deactivation.
                            </p>
                        </section>


                        <section>
                            <h4 class="text-lg font-semibold leading-7 text-gray-900"> 13. Severability </h4>
                            <p class="text-lg text-justify mt-2">
                                If any of these Terms and Conditions are held unenforceable by any competent
                                jurisdiction, this provision shall be limited to the minimum necessary, and the
                                remaining Terms and Conditions shall remain in full force and effect.

                            </p>
                        </section>


                        <section>
                            <h4 class="text-lg font-semibold leading-7 text-gray-900"> 13. Waiver </h4>
                            <p class="text-lg text-justify mt-2">
                                Our failure to enforce any of the Terms listed shall not constitute a waiver of our
                                rights to enforce these terms by you.

                            </p>
                        </section>

                        <section>
                            <h4 class="text-lg font-semibold leading-7 text-gray-900"> 15. Governing Law and
                                Jurisdiction </h4>
                            <p class="text-lg text-justify mt-2">
                                Your use of Banan and the terms and conditions hereunder are governed by and construed
                                in accordance with the laws of Sultanate of Oman, and Muscat Court shall have exclusive
                                jurisdiction to resolve any dispute relating to these Terms or the use of Banan
                                Application.

                            </p>
                        </section>



                    </article>
                </div>
            </div>
        </div>
    </section>
</main>

<app-footer></app-footer>